// @ts-nocheck
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Selectable from 'components/focus/Selectable';
import Image from 'components/common/Image';

import Ref from 'models/propTypes/ref';

import styles from './RectangleTile.module.scss';

const RectangleTile = ({
  logoSrc,
  title,
  focusId,
  className,
  onFocusSet,
  domRef,
  onClick,
}) => {
  return (
    <span className="flex-shrink-0" ref={domRef} key={focusId}>
      <Selectable
        onSelect={onClick}
        focusId={focusId}
        className={className}
        onFocusSet={onFocusSet}
        data-testid="media-tile"
        ttsText={title}
        render={({ hasFocus }) => (
          <div
            className={classNames(
              'd-flex',
              'flex-column',
              styles.tile,
              hasFocus ? styles.focused : styles.unfocused,
            )}
          >
            <button
              type="button"
              onClick={onClick}
              className={classNames('w-100 h-100', styles.button)}
            >
              <div
                className={classNames(
                  'w-100 h-100',
                  'd-flex flex-row align-items-center',
                )}
              >
                <Image
                  alt="logo"
                  src={logoSrc}
                  className={classNames(styles.rectangleLogo)}
                />

                <span className={styles.title}> {title}</span>
              </div>
            </button>
          </div>
        )}
      />
    </span>
  );
};

RectangleTile.propTypes = {
  title: PropTypes.string.isRequired,
  focusId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  onFocusSet: PropTypes.func,
  logoSrc: PropTypes.string.isRequired,
  domRef: Ref,
  onClick: PropTypes.func,
};

RectangleTile.defaultProps = {
  focusId: null,
  className: null,
  onFocusSet: () => {},
  domRef: null,
  onClick: () => {},
};

export default React.memo(
  React.forwardRef((props, ref) => <RectangleTile {...props} domRef={ref} />),
);
